module.exports = __webpack_public_path__ + "media/src/images/certificate_sample-df8894235b059cbd108ede819b90c6ec.jpg";